const EvChargerIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 22.5 19.5"
    fill="none"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.2168 2.59375C11.6308 2.59388 11.9667 2.92973 11.9668 3.34375V8.40918C11.9667 8.8232 11.6308 9.15905 11.2168 9.15918H5.28418C4.87005 9.15918 4.53431 8.82328 4.53418 8.40918V3.34375C4.53431 2.92965 4.87005 2.59375 5.28418 2.59375H11.2168ZM6.03418 7.65918H10.4668V4.09375H6.03418V7.65918Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.75 0C12.4793 0 13.1786 0.290054 13.6943 0.805664C14.2101 1.32139 14.5 2.02065 14.5 2.75V6.64062C15.7443 6.89315 16.6807 7.99271 16.6807 9.31152V13.9062C16.6809 14.721 17.3415 15.3815 18.1562 15.3818C18.9713 15.3818 19.6325 14.7212 19.6328 13.9062V7.99609C19.5363 7.87253 19.3809 7.74722 19.1514 7.58887C18.9667 7.46151 18.7096 7.29473 18.5137 7.09668C18.3283 6.90924 18.1603 6.65851 18.1211 6.33008L18.1123 6.18457V4.41602H19.0234V3.04883C19.0234 2.84184 19.1915 2.67403 19.3984 2.67383C19.6055 2.67383 19.7734 2.84172 19.7734 3.04883V4.41602H20.7354V3.04883C20.7354 2.84172 20.9032 2.67383 21.1104 2.67383C21.3173 2.67396 21.4854 2.8418 21.4854 3.04883V4.41602H22.4033V6.18457C22.4032 6.58505 22.2138 6.88242 22.0029 7.09766C21.8074 7.29716 21.5518 7.46562 21.3662 7.59473C21.1359 7.75499 20.9795 7.88025 20.8828 8.00195V13.9717H20.8799C20.8448 15.4467 19.6398 16.6318 18.1562 16.6318C16.6733 16.6315 15.4701 15.4471 15.4346 13.9727H15.4307V9.31152C15.4307 8.68899 15.0452 8.15725 14.5 7.94043V18H16.5V19.5H0V18H2V2.75C2 2.02074 2.29005 1.32137 2.80566 0.805664C3.3213 0.290025 4.02079 0 4.75 0H11.75ZM4.75 1.5C4.41861 1.5001 4.10054 1.63188 3.86621 1.86621C3.6319 2.10061 3.5 2.41857 3.5 2.75V18H13V2.75C13 2.41848 12.8682 2.10063 12.6338 1.86621C12.3994 1.6319 12.0814 1.5 11.75 1.5H4.75Z"
      fill="currentColor"
    />
  </svg>
);

export default EvChargerIcon;
